(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    const root = window.Shopify?.routes?.root || '/';

    const init = (page) => {
      const form = page.querySelector('[data-cart-form]');
      if (!form || form.dataset.ready) return;
      form.dataset.ready = 'true';
      const sectionId = page.dataset.sectionId;
      const t = JSON.parse(document.querySelector('[data-cart-strings]').textContent);

      const updateHeader = (count) => {
        const link = document.querySelector('.header-icon--cart');
        if (!link) return;
        let badge = link.querySelector('.header-icon__count');
        if (count > 0 && !badge) {
          badge = document.createElement('span');
          badge.className = 'header-icon__count';
          badge.setAttribute('aria-hidden', 'true');
          link.append(badge);
        }
        if (badge) {
          if (count > 0) badge.textContent = count > 99 ? '99+' : String(count);
          else badge.remove();
        }
        const label = link.querySelector('.visually-hidden');
        if (label) label.textContent = t.cartItems.replace('[count]', count);
      };

      const change = async (line, quantity, focusLine) => {
        form.setAttribute('aria-busy', 'true');
        try {
          const response = await fetch(`${root}cart/change.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ line, quantity, sections: [sectionId], sections_url: window.location.pathname }),
          });
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || t.error);
          const html = data.sections?.[sectionId];
          if (!html) { window.location.reload(); return; }
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('[data-cart-page]');
          page.replaceWith(fresh);
          updateHeader(data.item_count);
          init(fresh);
          const status = fresh.querySelector('[data-cart-status]');
          if (status) status.textContent = t.updated;
          const target = fresh.querySelector(`[data-line="${focusLine}"] [data-qty-input]`) || fresh.querySelector('.cart-page__title');
          target?.focus({ preventScroll: true });
        } catch (error) {
          form.removeAttribute('aria-busy');
          const status = page.querySelector('[data-cart-status]');
          if (status) status.textContent = error.message || t.error;
        }
      };

      page.querySelectorAll('[data-line]').forEach((row) => {
        const line = Number(row.dataset.line);
        const input = row.querySelector('[data-qty-input]');
        row.querySelectorAll('[data-qty-step]').forEach((button) => {
          button.addEventListener('click', () => {
            const next = Math.max(0, Number(input.value) + Number(button.dataset.qtyStep));
            change(line, next, line);
          });
        });
        input.addEventListener('change', () => {
          const max = Number(input.max) || Infinity;
          const next = Math.max(0, Math.min(max, parseInt(input.value, 10) || 0));
          change(line, next, line);
        });
        row.querySelector('[data-remove]').addEventListener('click', (event) => {
          event.preventDefault();
          change(line, 0, line);
        });
      });

      // Note de commande : enregistrée sans recharger la page.
      const note = form.querySelector('[data-cart-note]');
      let timer;
      note?.addEventListener('input', () => {
        clearTimeout(timer);
        timer = setTimeout(() => {
          fetch(`${root}cart/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ note: note.value }),
          });
        }, 400);
      });
    };

    document.querySelectorAll('[data-cart-page]').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cgc-about"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-about-gallery]').forEach((gallery) => {
    const track = gallery.querySelector('[data-about-track]');
    const slides = [...gallery.querySelectorAll('[data-about-slide]')];
    const dots = [...gallery.querySelectorAll('[data-about-dot]')];
    const prev = gallery.querySelector('[data-about-prev]');
    const next = gallery.querySelector('[data-about-next]');
    if (slides.length < 2) return;
    let current = 0;

    const update = (index) => {
      current = index;
      prev.disabled = index === 0;
      next.disabled = index === slides.length - 1;
      dots.forEach((dot, i) => {
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };

    const go = (index) => {
      const target = Math.max(0, Math.min(slides.length - 1, index));
      track.scrollTo({ left: slides[target].offsetLeft - slides[0].offsetLeft });
      update(target);
    };

    let frame;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const index = Math.round(track.scrollLeft / track.clientWidth);
        if (index !== current) update(index);
      });
    });

    prev.addEventListener('click', () => go(current - 1));
    next.addEventListener('click', () => go(current + 1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => go(i)));
    track.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight') { event.preventDefault(); go(current + 1); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); go(current - 1); }
    });

    update(0);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cgc-contact"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const status = document.querySelector('[data-form-status]');
    if (status) status.focus();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cgc-events"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const pad = (n) => String(n).padStart(2, '0');
    const keyOf = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    const parseKey = (key) => {
      const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(key || '');
      if (!m) return null;
      const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
      return keyOf(d) === key ? d : null;
    };
    const addDays = (d, n) => new Date(d.getFullYear(), d.getMonth(), d.getDate() + n);
    const startOfWeek = (d) => addDays(d, -((d.getDay() + 6) % 7));
    const startOfMonth = (d) => new Date(d.getFullYear(), d.getMonth(), 1);
    const endOfMonth = (d) => new Date(d.getFullYear(), d.getMonth() + 1, 0);
    const addMonths = (d, n) => {
      const target = new Date(d.getFullYear(), d.getMonth() + n, 1);
      const last = endOfMonth(target).getDate();
      return new Date(target.getFullYear(), target.getMonth(), Math.min(d.getDate(), last));
    };
    const fill = (template, values) => template.replace(/\[(\w+)\]/g, (_, k) => (k in values ? values[k] : ''));

    const init = (root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';

      const container = root.closest('.events-page');
      const stringsEl = container?.querySelector('[data-cgc-events-strings]');
      const decoder = document.createElement('textarea');
      const decode = (value) => { decoder.innerHTML = value; return decoder.value; };
      const t = Object.fromEntries(Object.entries(stringsEl ? JSON.parse(stringsEl.textContent) : {}).map(([k, v]) => [k, decode(v)]));
      const locale = t.locale || document.documentElement.lang || 'fr';
      const fmt = (options) => new Intl.DateTimeFormat(locale, options);
      const fmtMonth = fmt({ month: 'long', year: 'numeric' });
      const fmtLong = fmt({ weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
      const fmtDayMonth = fmt({ day: 'numeric', month: 'long' });
      const fmtShortMonth = fmt({ month: 'short' });
      const fmtWeekday = fmt({ weekday: 'short' });
      const fmtWeekdayLong = fmt({ weekday: 'long' });
      const count = (n) => (n === 0 ? t.countNone : n === 1 ? t.countOne : fill(t.countOther, { count: n }));

      const calendar = root.querySelector('[data-calendar]');
      const grid = root.querySelector('[data-grid]');
      const periodEl = root.querySelector('[data-period]');
      const listHeading = root.querySelector('[data-list-heading]');
      const statusEl = root.querySelector('[data-status]');
      const resetBtn = root.querySelector('[data-reset]');
      const list = root.querySelector('[data-list]');
      const empty = root.querySelector('[data-empty]');
      const emptyTitle = root.querySelector('[data-empty-title]');
      const emptyText = root.querySelector('[data-empty-text]');
      const nextBtn = root.querySelector('[data-next-event]');
      const helpId = root.querySelector('[id^="EventsHelp-"]')?.id;
      const today = (() => { const n = new Date(); return new Date(n.getFullYear(), n.getMonth(), n.getDate()); })();

      const items = [...root.querySelectorAll('[data-event]')]
        .map((el) => ({ el, date: parseKey(el.dataset.date), start: el.dataset.start || '', title: el.dataset.title || '', game: el.dataset.game || 'cgc' }))
        .filter((item) => item.date);
      items.sort((a, b) => keyOf(a.date).localeCompare(keyOf(b.date)) || a.start.localeCompare(b.start));
      items.forEach((item) => list?.appendChild(item.el));
      root.querySelectorAll('[data-event]').forEach((el) => { if (!parseKey(el.dataset.date)) el.hidden = true; });

      const byDay = new Map();
      items.forEach((item) => {
        const key = keyOf(item.date);
        if (!byDay.has(key)) byDay.set(key, []);
        byDay.get(key).push(item);

        const long = item.el.querySelector('[data-long-date]');
        if (long) long.textContent = fmtLong.format(item.date);
        const month = item.el.querySelector('[data-month]');
        if (month) month.textContent = fmtShortMonth.format(item.date).replace('.', '');
        const past = item.el.querySelector('[data-past]');
        if (past) past.hidden = item.date >= today;
        item.el.classList.toggle('events__item--past', item.date < today);
      });

      const views = ['month', 'week', 'day'];
      const state = {
        view: views.includes(root.dataset.defaultView) ? root.dataset.defaultView : 'month',
        cursor: today,
        selected: null,
      };

      const range = () => {
        if (state.selected) return [state.selected, state.selected];
        if (state.view === 'month') return [startOfMonth(state.cursor), endOfMonth(state.cursor)];
        if (state.view === 'week') { const s = startOfWeek(state.cursor); return [s, addDays(s, 6)]; }
        return [state.cursor, state.cursor];
      };

      const periodLabel = () => {
        if (state.view === 'month') return fmtMonth.format(state.cursor);
        if (state.view === 'week') {
          const s = startOfWeek(state.cursor);
          const e = addDays(s, 6);
          const startLabel = s.getMonth() === e.getMonth() ? String(s.getDate()) : fmtDayMonth.format(s);
          return fill(t.weekLabel, { start: startLabel, end: `${fmtDayMonth.format(e)} ${e.getFullYear()}` });
        }
        return fmtLong.format(state.cursor);
      };

      const dayButton = (date, { outside = false, withTitles = false } = {}) => {
        const key = keyOf(date);
        const events = byDay.get(key) || [];
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'events-day';
        button.dataset.date = key;
        button.tabIndex = keyOf(state.cursor) === key ? 0 : -1;
        if (outside) button.classList.add('events-day--outside');
        if (events.length) button.classList.add('events-day--has-events');
        if (key === keyOf(today)) {
          button.classList.add('events-day--today');
          button.setAttribute('aria-current', 'date');
        }
        button.setAttribute('aria-pressed', state.selected && keyOf(state.selected) === key ? 'true' : 'false');
        let label = fmtLong.format(date);
        if (key === keyOf(today)) label += ` ${t.today}`;
        label += `, ${count(events.length)}`;
        button.setAttribute('aria-label', label);
        if (helpId) button.setAttribute('aria-describedby', helpId);

        if (withTitles) {
          const head = document.createElement('span');
          head.className = 'events-day__label';
          head.innerHTML = `<span class="events-day__weekday"></span><span class="events-day__number"></span>`;
          head.firstChild.textContent = fmtWeekday.format(date).replace('.', '');
          head.lastChild.textContent = date.getDate();
          button.appendChild(head);
          if (events.length) {
            const ul = document.createElement('ul');
            ul.className = 'events-day__titles';
            events.forEach((ev) => {
              const li = document.createElement('li');
              li.textContent = ev.start ? `${ev.start.replace(':', ' h ')} · ${ev.title}` : ev.title;
              ul.appendChild(li);
            });
            button.appendChild(ul);
          } else {
            const none = document.createElement('span');
            none.className = 'events-day__empty';
            none.textContent = '—';
            button.appendChild(none);
          }
        } else {
          const number = document.createElement('span');
          number.className = 'events-day__number';
          number.textContent = date.getDate();
          button.appendChild(number);
          const marks = document.createElement('span');
          marks.className = 'events-day__marks';
          // Une pastille par jeu différent ce jour-là (Pokémon, One Piece, Yu-Gi-Oh!, sinon CGC).
          [...new Set(events.map((ev) => ev.game))].slice(0, 3).forEach((game) => {
            const mark = document.createElement('span');
            mark.className = 'events-day__mark';
            if (game !== 'cgc') mark.classList.add(`events-day__mark--${game}`);
            marks.appendChild(mark);
          });
          button.appendChild(marks);
        }
        return button;
      };

      const renderMonth = () => {
        const table = document.createElement('table');
        table.className = 'events-month';
        table.setAttribute('aria-label', fill(t.gridLabel, { period: fmtMonth.format(state.cursor) }));
        const thead = table.createTHead();
        const headRow = thead.insertRow();
        const first = startOfWeek(startOfMonth(state.cursor));
        for (let i = 0; i < 7; i += 1) {
          const day = addDays(first, i);
          const th = document.createElement('th');
          th.scope = 'col';
          const abbr = document.createElement('abbr');
          abbr.title = fmtWeekdayLong.format(day);
          abbr.textContent = fmtWeekday.format(day).replace('.', '');
          th.appendChild(abbr);
          headRow.appendChild(th);
        }
        const body = table.createTBody();
        const last = endOfMonth(state.cursor);
        let day = first;
        while (day <= last || (day.getDay() + 6) % 7 !== 0) {
          const row = body.insertRow();
          for (let i = 0; i < 7; i += 1) {
            const cell = row.insertCell();
            cell.appendChild(dayButton(day, { outside: day.getMonth() !== state.cursor.getMonth() }));
            day = addDays(day, 1);
          }
        }
        return table;
      };

      const renderWeek = () => {
        const ul = document.createElement('ul');
        ul.className = 'events-week';
        ul.setAttribute('role', 'list');
        ul.setAttribute('aria-label', fill(t.gridLabel, { period: periodLabel() }));
        const start = startOfWeek(state.cursor);
        for (let i = 0; i < 7; i += 1) {
          const li = document.createElement('li');
          li.appendChild(dayButton(addDays(start, i), { withTitles: true }));
          ul.appendChild(li);
        }
        return ul;
      };

      const renderDay = () => {
        const events = byDay.get(keyOf(state.cursor)) || [];
        const box = document.createElement('div');
        box.className = 'events-single';
        box.innerHTML = '<span class="events-single__number" aria-hidden="true"></span><span class="events-single__text"><span class="events-single__weekday"></span><span class="events-single__count"></span></span>';
        box.querySelector('.events-single__number').textContent = state.cursor.getDate();
        box.querySelector('.events-single__weekday').textContent = fmtLong.format(state.cursor) + (keyOf(state.cursor) === keyOf(today) ? ` ${t.today}` : '');
        box.querySelector('.events-single__count').textContent = count(events.length);
        return box;
      };

      const navLabels = {
        month: [t.prevMonth, t.nextMonth],
        week: [t.prevWeek, t.nextWeek],
        day: [t.prevDay, t.nextDay],
      };

      const render = ({ focus = false } = {}) => {
        root.dataset.view = state.view;
        root.querySelectorAll('[data-view]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.view === state.view)));
        const [prevLabel, nextLabel] = navLabels[state.view];
        root.querySelector('[data-nav-label="prev"]').textContent = prevLabel;
        root.querySelector('[data-nav-label="next"]').textContent = nextLabel;
        periodEl.textContent = periodLabel();

        grid.replaceChildren(state.view === 'month' ? renderMonth() : state.view === 'week' ? renderWeek() : renderDay());

        const [from, to] = range();
        const visible = items.filter((item) => item.date >= from && item.date <= to);
        items.forEach((item) => { item.el.hidden = !visible.includes(item); });

        const scopeLabel = state.selected || state.view === 'day' ? fmtLong.format(from) : periodLabel();
        const headingTemplate = state.selected || state.view === 'day' ? t.headingDay : state.view === 'week' ? t.headingWeek : t.headingMonth;
        listHeading.textContent = fill(headingTemplate, { period: scopeLabel });
        statusEl.textContent = items.length ? count(visible.length) : '';

        if (state.selected && state.view !== 'day') {
          resetBtn.hidden = false;
          resetBtn.textContent = state.view === 'month' ? t.resetMonth : t.resetWeek;
        } else {
          resetBtn.hidden = true;
        }

        const noEvents = items.length === 0;
        empty.hidden = visible.length > 0;
        if (!noEvents) {
          emptyTitle.textContent = state.selected || state.view === 'day' ? t.emptyDay : t.emptyPeriod;
          emptyText.hidden = true;
          const upcoming = items.find((item) => item.date > to);
          if (upcoming) {
            nextBtn.hidden = false;
            nextBtn.textContent = fill(t.nextEvent, { date: fmtDayMonth.format(upcoming.date) });
            nextBtn.onclick = () => {
              state.cursor = upcoming.date;
              state.selected = state.view === 'day' ? null : upcoming.date;
              render();
              listHeading.setAttribute('tabindex', '-1');
              listHeading.focus();
            };
          } else {
            nextBtn.hidden = true;
          }
        }

        if (focus) grid.querySelector('.events-day[tabindex="0"]')?.focus();
      };

      root.querySelectorAll('[data-view]').forEach((button) => {
        button.addEventListener('click', () => {
          state.view = button.dataset.view;
          if (state.selected) state.cursor = state.selected;
          state.selected = null;
          render();
        });
      });

      root.querySelector('[data-nav="prev"]').addEventListener('click', () => move(-1));
      root.querySelector('[data-nav="next"]').addEventListener('click', () => move(1));
      root.querySelector('[data-nav="today"]').addEventListener('click', () => {
        state.cursor = today;
        state.selected = null;
        render();
      });

      const move = (direction) => {
        if (state.view === 'month') state.cursor = startOfMonth(addMonths(state.cursor, direction));
        else if (state.view === 'week') state.cursor = addDays(state.cursor, 7 * direction);
        else state.cursor = addDays(state.cursor, direction);
        state.selected = null;
        render();
      };

      resetBtn.addEventListener('click', () => {
        state.selected = null;
        render();
        listHeading.setAttribute('tabindex', '-1');
        listHeading.focus();
      });

      grid.addEventListener('click', (event) => {
        const button = event.target.closest('.events-day');
        if (!button) return;
        const date = parseKey(button.dataset.date);
        const isSelected = state.selected && keyOf(state.selected) === button.dataset.date;
        state.cursor = date;
        state.selected = isSelected ? null : date;
        render({ focus: true });
      });

      grid.addEventListener('keydown', (event) => {
        const button = event.target.closest('.events-day');
        if (!button) return;
        const current = parseKey(button.dataset.date);
        const vertical = state.view === 'month' ? 7 : 1;
        const moves = {
          ArrowLeft: () => addDays(current, -1),
          ArrowRight: () => addDays(current, 1),
          ArrowUp: () => addDays(current, -vertical),
          ArrowDown: () => addDays(current, vertical),
          Home: () => startOfWeek(current),
          End: () => addDays(startOfWeek(current), 6),
          PageUp: () => addMonths(current, event.shiftKey ? -12 : -1),
          PageDown: () => addMonths(current, event.shiftKey ? 12 : 1),
        };
        if (!moves[event.key]) return;
        event.preventDefault();
        state.cursor = moves[event.key]();
        if (state.selected) state.selected = null;
        render({ focus: true });
      });

      calendar.hidden = false;
      render();
    };

    const boot = () => document.querySelectorAll('[data-cgc-events]').forEach(init);
    boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cgc-hero"] && !Shopify.designMode) return;
  try {
    
  // Carte à deux onglets : clic, flèches gauche/droite, Début/Fin.
  document.querySelectorAll('[data-hero-tabs]').forEach((card) => {
    const tabs = [...card.querySelectorAll('[data-hero-tab]')];
    const select = (tab, focus) => {
      tabs.forEach((item) => {
        const selected = item === tab;
        item.setAttribute('aria-selected', String(selected));
        item.tabIndex = selected ? 0 : -1;
        document.getElementById(item.getAttribute('aria-controls')).hidden = !selected;
      });
      if (focus) tab.focus();
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(tab, false));
      tab.addEventListener('keydown', (event) => {
        const moves = { ArrowRight: index + 1, ArrowLeft: index - 1, Home: 0, End: tabs.length - 1 };
        if (!(event.key in moves)) return;
        event.preventDefault();
        select(tabs[(moves[event.key] + tabs.length) % tabs.length], true);
      });
    });
  });

  // Carte « Communauté » : affiche le prochain événement publié sur la page
  // Événements (liste rendue par la section cgc-events). Sans événement à
  // venir, ou en cas d'erreur, la carte garde son texte d'origine.
  document.querySelectorAll('[data-next-event]').forEach(async (card) => {
    const slot = card.querySelector('[data-next-event-slot]');
    if (!slot) return;
    try {
      const response = await fetch(card.dataset.nextEvent, { headers: { Accept: 'text/html' } });
      if (!response.ok) return;
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const now = new Date();
      const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
      const next = [...doc.querySelectorAll('[data-event]')]
        .map((item) => ({
          date: item.dataset.date || '',
          start: item.dataset.start || '',
          title: item.dataset.title || '',
          location: item.dataset.location || '',
          description: item.querySelector('.event-card__description')?.textContent.trim() || '',
        }))
        .filter((event) => /^\d{4}-\d{2}-\d{2}$/.test(event.date) && event.title && event.date >= today)
        .sort((a, b) => `${a.date}T${a.start}`.localeCompare(`${b.date}T${b.start}`))[0];
      if (!next) return;

      const [year, month, day] = next.date.split('-').map(Number);
      const dateLabel = new Intl.DateTimeFormat(document.documentElement.lang || 'fr', {
        weekday: 'long', day: 'numeric', month: 'long',
      }).format(new Date(year, month - 1, day));
      const facts = [dateLabel];
      if (next.start) facts.push(next.start.replace(':', ' h '));
      if (next.location) facts.push(next.location);

      const make = (tag, className, text) => {
        const el = document.createElement(tag);
        el.className = className;
        el.textContent = text;
        return el;
      };
      const time = make('time', '', facts.shift());
      time.dateTime = next.start ? `${next.date}T${next.start}` : next.date;
      const meta = make('p', 'hero-card__event-meta', '');
      meta.append(time, facts.length ? ` · ${facts.join(' · ')}` : '');
      slot.replaceChildren(make('p', 'hero-card__event-label', slot.dataset.label), make('p', 'hero-card__event-title', next.title), meta);
      if (!next.location && next.description) {
        const short = next.description.length > 90 ? `${next.description.slice(0, 88).trimEnd()}…` : next.description;
        slot.append(make('p', 'hero-card__event-meta', short));
      }
      card.querySelector('.hero-card__text')?.setAttribute('hidden', '');
      slot.hidden = false;
    } catch (error) {
      // La carte reste telle quelle.
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cgc-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-recommendations]').forEach(async (root) => {
    if (root.children.length) return;
    try {
      const response = await fetch(root.dataset.url);
      if (!response.ok) return;
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.children.length) root.replaceChildren(...fresh.children);
    } catch (error) {
      // Pas de recommandations : la section reste vide et masquée.
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cgc-services"] && !Shopify.designMode) return;
  try {
    
  // Élément personnalisé : il se réactive tout seul quand la section est
  // réinsérée (éditeur de thème, rechargement à chaud de l'aperçu local).
  if (!customElements.get('cgc-services-tabs')) {
    customElements.define('cgc-services-tabs', class extends HTMLElement {
      connectedCallback() {
        const tablist = this.querySelector('[data-services-tablist]');
        this.tabs = [...this.querySelectorAll('[data-services-tab]')];
        this.panels = [...this.querySelectorAll('[data-services-panel]')];
        if (!tablist || this.tabs.length < 2 || this.dataset.ready) return;
        this.dataset.ready = 'true';

        this.panels.forEach((panel) => {
          panel.setAttribute('role', 'tabpanel');
          panel.tabIndex = 0;
        });
        tablist.hidden = false;
        this.select(Math.max(0, this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true')), false);

        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.select(i, false));
          tab.addEventListener('keydown', (event) => {
            const keys = { ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: this.tabs.length - 1 };
            if (!(event.key in keys)) return;
            event.preventDefault();
            this.select((keys[event.key] + this.tabs.length) % this.tabs.length, true);
          });
        });

        // Éditeur de thème : afficher l'onglet du bloc sélectionné.
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.panels.findIndex((panel) => panel.contains(event.target));
          if (index >= 0) this.select(index, false);
        });
      }

      select(index, focus) {
        this.tabs.forEach((tab, i) => {
          const active = i === index;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          this.panels[i].hidden = !active;
        });
        if (focus) this.tabs[index].focus();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (() => {
    const setup = (root) => {
      if (root.dataset.tabsReady) return;
      root.dataset.tabsReady = 'true';
      const list = root.querySelector('[data-tablist]');
      const tabs = [...list.querySelectorAll('[data-tab]')];
      const panels = new Map([...root.querySelectorAll('[data-panel]')].map((panel) => [panel.dataset.panel, panel]));
      if (!tabs.length) return;

      root.classList.add('is-enhanced');
      list.setAttribute('role', 'tablist');
      list.setAttribute('aria-orientation', 'horizontal');
      tabs.forEach((tab) => {
        tab.setAttribute('role', 'tab');
        const panel = panels.get(tab.dataset.tab);
        if (!panel) return;
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tab.id);
        panel.tabIndex = 0;
      });

      const select = (name, { focus = false, updateHash = false } = {}) => {
        const target = tabs.find((tab) => tab.dataset.tab === name) || tabs[0];
        tabs.forEach((tab) => {
          const active = tab === target;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          const panel = panels.get(tab.dataset.tab);
          if (panel) panel.hidden = !active;
        });
        if (focus) target.focus();
        // Keep the selected tab visible in the scrollable tab bar, but never
        // move the page on first load.
        if (focus || updateHash) target.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        if (updateHash) {
          const url = new URL(window.location.href);
          url.hash = target.dataset.tab === tabs[0].dataset.tab ? '' : `onglet-${target.dataset.tab}`;
          history.replaceState(history.state, '', url);
        }
      };

      const fromHash = () => decodeURIComponent(window.location.hash.slice(1)).replace(/^onglet-/, '');

      list.addEventListener('click', (event) => {
        const tab = event.target.closest('[data-tab]');
        if (!tab) return;
        event.preventDefault();
        select(tab.dataset.tab, { updateHash: true });
      });

      list.addEventListener('keydown', (event) => {
        const index = tabs.indexOf(document.activeElement);
        if (index === -1) return;
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else if (event.key === ' ' || event.key === 'Spacebar') {
          event.preventDefault();
          select(tabs[index].dataset.tab, { updateHash: true });
          return;
        } else return;
        event.preventDefault();
        select(tabs[next].dataset.tab, { focus: true, updateHash: true });
      });

      root.addEventListener('click', (event) => {
        const link = event.target.closest('[data-tab-link]');
        if (!link) return;
        event.preventDefault();
        select(link.dataset.tabLink, { focus: true, updateHash: true });
      });

      window.addEventListener('hashchange', () => {
        if (tabs.some((tab) => tab.dataset.tab === fromHash())) select(fromHash());
      });

      select(fromHash());
    };

    const init = () => document.querySelectorAll('[data-collection-tabs]').forEach(setup);
    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    const close = (event) => {
      document.querySelectorAll('[data-footer-policies][open]').forEach((menu) => {
        if (event.type === 'keydown') {
          if (event.key !== 'Escape') return;
          menu.open = false;
          menu.querySelector('summary').focus();
        } else if (!menu.contains(event.target)) {
          menu.open = false;
        }
      });
    };
    document.addEventListener('click', close);
    document.addEventListener('keydown', close);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const selector = '[data-header] details[data-disclosure]';

    const close = (disclosure, restoreFocus) => {
      if (!disclosure.open) return;
      disclosure.open = false;
      if (restoreFocus) disclosure.querySelector(':scope > summary')?.focus();
    };

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const openDisclosures = [...document.querySelectorAll(`${selector}[open]`)];
      const innermost = openDisclosures.filter((d) => d.contains(document.activeElement)).pop();
      if (innermost) {
        close(innermost, true);
      } else {
        openDisclosures.forEach((d) => close(d, false));
      }
    });

    document.addEventListener('click', (event) => {
      document.querySelectorAll(`${selector}[open]`).forEach((disclosure) => {
        if (!disclosure.contains(event.target)) close(disclosure, false);
      });

      const link = event.target.closest?.('[data-header] details[data-disclosure] a[href]');
      if (link) {
        document.querySelectorAll(`${selector}[open]`).forEach((d) => close(d, false));
      }
    });

    document.addEventListener('toggle', (event) => {
      const opened = event.target;
      if (!opened.matches?.(selector) || !opened.open) return;
      document.querySelectorAll(`${selector}[open]`).forEach((disclosure) => {
        if (disclosure !== opened && !disclosure.contains(opened)) close(disclosure, false);
      });
    }, true);

    document.addEventListener('focusout', (event) => {
      const dropdown = event.target.closest?.('[data-header] .site-nav__dropdown[open], [data-header] .site-header__localization details[open]');
      if (dropdown && event.relatedTarget && !dropdown.contains(event.relatedTarget)) {
        close(dropdown, false);
      }
    });

    const hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
    const closeDelay = 250;

    document.querySelectorAll('[data-header] .site-nav__dropdown').forEach((dropdown) => {
      const summary = dropdown.querySelector(':scope > summary');
      let closeTimer;
      let openedByHover = false;

      const cancelClose = () => window.clearTimeout(closeTimer);

      dropdown.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'mouse' || !hoverQuery.matches) return;
        cancelClose();
        if (!dropdown.open) {
          openedByHover = true;
          dropdown.open = true;
        }
      });

      dropdown.addEventListener('pointerleave', (event) => {
        if (event.pointerType !== 'mouse' || !openedByHover) return;
        cancelClose();
        closeTimer = window.setTimeout(() => {
          if (dropdown.contains(document.activeElement) && document.activeElement !== summary) return;
          openedByHover = false;
          close(dropdown, false);
        }, closeDelay);
      });

      summary.addEventListener('click', (event) => {
        cancelClose();
        if (openedByHover && dropdown.open) {
          event.preventDefault();
          openedByHover = false;
        }
      });

      dropdown.addEventListener('toggle', () => {
        if (!dropdown.open) {
          openedByHover = false;
          cancelClose();
        }
      });
    });

    window.matchMedia('(min-width: 1280px)').addEventListener('change', (event) => {
      if (!event.matches) return;
      document.querySelectorAll('[data-header] [data-mobile-menu][open]').forEach((d) => close(d, false));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    // ---------- Galerie (diaporama, vignettes, clavier, zoom) ----------
    document.querySelectorAll('[data-gallery]').forEach((gallery) => {
      const track = gallery.querySelector('[data-gallery-track]');
      const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
      const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
      const prev = gallery.querySelector('[data-gallery-prev]');
      const next = gallery.querySelector('[data-gallery-next]');
      const counter = gallery.querySelector('[data-gallery-counter]');
      const dialog = gallery.querySelector('[data-gallery-dialog]');
      const zoom = gallery.querySelector('[data-gallery-zoom]');
      let current = 0;

      const update = (index) => {
        current = index;
        if (counter) counter.textContent = `${index + 1} / ${slides.length}`;
        if (prev) prev.disabled = index === 0;
        if (next) next.disabled = index === slides.length - 1;
        thumbs.forEach((thumb, i) => {
          if (i === index) thumb.setAttribute('aria-current', 'true');
          else thumb.removeAttribute('aria-current');
        });
      };

      const go = (index) => {
        const target = Math.max(0, Math.min(slides.length - 1, index));
        track.scrollTo({ left: slides[target].offsetLeft - slides[0].offsetLeft });
        update(target);
      };

      let frame;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const index = Math.round(track.scrollLeft / track.clientWidth);
          if (index !== current) update(index);
        });
      });

      prev?.addEventListener('click', () => go(current - 1));
      next?.addEventListener('click', () => go(current + 1));
      thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => go(i)));
      track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') { event.preventDefault(); go(current + 1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); go(current - 1); }
      });

      if (dialog && typeof dialog.showModal === 'function') {
        const image = dialog.querySelector('[data-gallery-dialog-image]');
        const open = () => {
          const slide = slides[current];
          image.src = slide.dataset.zoomSrc;
          image.alt = slide.querySelector('img')?.alt || '';
          dialog.showModal();
        };
        zoom?.addEventListener('click', open);
        slides.forEach((slide) => slide.querySelector('img')?.addEventListener('click', open));
        dialog.querySelector('[data-gallery-dialog-close]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
      } else {
        zoom?.remove();
      }

      update(0);
    });

    // ---------- Carte d'achat ----------
    document.querySelectorAll('[data-product-page]').forEach((page) => {
      const form = page.querySelector('[data-product-form]');
      if (!form) return;
      const variants = JSON.parse(page.querySelector('[data-product-variants]').textContent);
      const t = JSON.parse(page.querySelector('[data-product-strings]').textContent);
      const qty = form.querySelector('[data-qty-input]');
      const minus = form.querySelector('[data-qty-minus]');
      const plus = form.querySelector('[data-qty-plus]');
      const addButton = form.querySelector('[data-add-button]');
      const message = form.querySelector('[data-form-message]');
      const actions = form.querySelector('[data-buy-actions]');
      const dynamic = form.querySelector('[data-dynamic-checkout]');
      const soldOut = page.querySelector('[data-sold-out]');
      const stock = page.querySelector('[data-stock]');
      const toast = page.querySelector('[data-cart-toast]');
      const sticky = page.querySelector('[data-sticky-buy]');

      const currentVariant = () => {
        const checked = form.querySelector('[data-variant-input]:checked');
        const select = form.querySelector('[data-variant-select]');
        const hidden = form.querySelector('input[type="hidden"][name="id"]');
        const id = Number((checked || select || hidden).value);
        return variants.find((v) => v.id === id) || variants[0];
      };

      const clampQty = () => {
        const max = Number(qty.max) || Infinity;
        let value = Math.max(1, Math.min(max, parseInt(qty.value, 10) || 1));
        qty.value = value;
        minus.disabled = value <= 1;
        plus.disabled = value >= max;
      };

      const render = () => {
        const v = currentVariant();
        page.querySelector('[data-price-current]').textContent = v.price;
        page.querySelector('[data-sticky-price]').textContent = v.price;
        const compareWrap = page.querySelector('[data-price-compare-wrap]');
        compareWrap.hidden = !v.compare;
        if (v.compare) page.querySelector('[data-price-compare]').textContent = v.compare;
        const optionValue = page.querySelector('[data-option-value]');
        if (optionValue) optionValue.textContent = v.title;

        const lowStock = page.dataset.lowStock === 'true';
        const state = !v.available ? 'out' : lowStock && v.max === 1 ? 'last' : 'in';
        stock.className = `buy-card__stock buy-card__stock--${state}`;
        stock.querySelector('[data-stock-label]').textContent = state === 'out' ? t.soldOut : state === 'last' ? t.stockLast : t.stockIn;

        actions.hidden = !v.available;
        if (dynamic) dynamic.hidden = !v.available;
        soldOut.hidden = v.available;
        if (v.max) qty.max = v.max; else qty.removeAttribute('max');
        clampQty();
        message.hidden = true;

        const url = new URL(window.location.href);
        if (variants.length > 1) {
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url);
        }
      };

      form.querySelectorAll('[data-variant-input], [data-variant-select]').forEach((input) => input.addEventListener('change', render));
      minus.addEventListener('click', () => { qty.value = Number(qty.value) - 1; clampQty(); });
      plus.addEventListener('click', () => { qty.value = Number(qty.value) + 1; clampQty(); });
      qty.addEventListener('change', clampQty);
      clampQty();

      // Description longue : repliée avec « Lire la suite ».
      const description = page.querySelector('[data-description]');
      if (description) {
        const text = description.querySelector('[data-description-text]');
        const toggle = description.querySelector('[data-description-toggle]');
        if (text.scrollHeight > 200) {
          description.classList.add('is-clamped');
          toggle.hidden = false;
          toggle.addEventListener('click', () => {
            const open = description.classList.toggle('is-clamped') === false;
            toggle.setAttribute('aria-expanded', String(open));
            toggle.querySelector('[data-more-label]').hidden = open;
            toggle.querySelector('[data-less-label]').hidden = !open;
          });
        }
      }

      // Ajout au panier sans quitter la page.
      const updateCartCount = (count) => {
        const link = document.querySelector('.header-icon--cart');
        if (!link) return;
        let badge = link.querySelector('.header-icon__count');
        if (!badge && count > 0) {
          badge = document.createElement('span');
          badge.className = 'header-icon__count';
          badge.setAttribute('aria-hidden', 'true');
          link.append(badge);
        }
        if (badge) badge.textContent = count > 99 ? '99+' : String(count);
        const label = link.querySelector('.visually-hidden');
        if (label) label.textContent = t.cartItems.replace('[count]', count);
        const toastCount = toast.querySelector('[data-cart-toast-count]');
        if (toastCount) toastCount.textContent = count;
      };

      const closeToast = () => { toast.hidden = true; };
      toast.querySelectorAll('[data-cart-toast-close]').forEach((b) => b.addEventListener('click', () => { closeToast(); addButton.focus(); }));
      document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !toast.hidden) closeToast(); });

      form.addEventListener('submit', async (event) => {
        if (!window.fetch) return;
        event.preventDefault();
        if (addButton.getAttribute('aria-busy') === 'true') return;
        addButton.setAttribute('aria-busy', 'true');
        const label = addButton.querySelector('span');
        label.textContent = t.adding;
        message.hidden = true;
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form),
          });
          const data = await response.json();
          if (!response.ok) {
            message.textContent = data.description || data.message || t.error;
            message.hidden = false;
            return;
          }
          const cart = await (await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)).json();
          updateCartCount(cart.item_count);
          const v = currentVariant();
          toast.querySelector('[data-cart-toast-variant]').textContent = variants.length > 1 ? `${v.title} · × ${qty.value}` : `× ${qty.value}`;
          toast.hidden = false;
          toast.querySelector('.button--radiant').focus();
        } catch (error) {
          form.submit();
        } finally {
          addButton.removeAttribute('aria-busy');
          label.textContent = t.addToCart;
        }
      });

      // Barre d'achat collante sur mobile.
      if (sticky && 'IntersectionObserver' in window) {
        sticky.hidden = false;
        const observer = new IntersectionObserver(([entry]) => {
          const show = !entry.isIntersecting && entry.boundingClientRect.top < 0 && !actions.hidden;
          sticky.classList.toggle('is-visible', show);
        });
        observer.observe(actions);
        sticky.querySelector('[data-sticky-add]').addEventListener('click', () => {
          if (typeof form.requestSubmit === 'function') form.requestSubmit(addButton);
          else addButton.click();
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
